<template>
  <div class="tab">
    <div>
      <span @click="returnFun()">＜返回</span>
      <h4>提升心理弹性，促进积极发展</h4>
      <p>不同于传统的“问题”和“病理”等缺陷视角，心理弹性视角更关注儿童青少年在发展性逆境、压力或创伤事件下的良好适应乃至积极发展，强调儿童是发展的潜在资源，具有很强的可塑性。同时，多维度环境中的良好资源也对儿童的发展和成长产生重要的影响。</p>
      <p>心理弹性视角下的干预基于优势取向视角（strength-based model），强调通过干预提升个体的多种保护性因素 （包括自尊、积极的应对方式、认知重建、情绪管理、社会支持等），并认为每个孩子都有其内在的积极资源和向上的力量，包括流动儿童、留守儿童等处境不利儿童。基于此视角和理念，我们设计了本套心理弹性干预方案，旨在通过系列干预活动引导孩子们认识、欣赏自己身上的优势和品质，同时看到并利用身边环境中的资源和力量，提升压力和逆境下的心理弹性，并促进他们的健康成长与积极发展。</p>
      <img src="../../assets/list1.png" alt="">
      <img src="../../assets/list1_1.png" alt="">
      <h5>心理弹性干预活动形式</h5>
      <p>我们主要采取的干预活动分为两大类，分别是热身类活动和主题类活动。热身类活动包括两个环节：参与体验和分享讨论。主题类活动是结合某一个主题设计的体验活动，目的是通过活动引发孩子在这一主题上的觉察、反思与成长。主题活动的基本步骤包含：参与体验、分享讨论、巩固提升和实践练习。活动形式也具有多样性，包括情景模拟、心理游戏、绘本、视频分享、角色扮演和行为演练等等。</p>
      <img src="../../assets/list1_2.png" alt="">
      <h5>心理弹性干预八次活动</h5>
      <p>第一次活动：七彩的生活</p>
      <p>第二次活动：我是调整情绪小专家（1）</p>
      <p>第三次活动：我是调整情绪小专家（2）</p>
      <p>第四次活动：积极乐园</p>
      <p>第五次活动：冲突解决秘笈会</p>
      <p>第六次活动：父母沟通有高招</p>
      <p>第七次活动：我是一棵嫁接的树</p>
      <p>第八次活动：我的未来我做主</p>
      <img src="../../assets/list1_3.png" alt="">
      <h4>心理弹性干预活动示例</h4>
      <h5>“七彩的生活”主题活动之一：“我的七彩北京生活”</h5>
      <p>目的：了解孩子的北京生活，体验生活是丰富多彩的。</p>
      <p>过程：给每一个孩子派发《我的七彩北京生活》工作纸，写上在北京生活中开心的事和不开心的事，涂上不同的颜色作背景，最后进行组内分享。</p>
      <img src="../../assets/list1_4.png" alt="">
      <h5>“我是调整情绪小专家（2）”主题活动之一：“寻宝”</h5>
      <p>目的：整理并总结情绪调节的方法，尝试找到自己最喜欢的调节方法应对不良情绪。</p>
      <p>过程：组长事先在教室中藏好苹果贴纸，让孩子们在教室中找到藏好的苹果纸贴，并写上自己最喜欢的情绪调节方法，最后进行组内分享，总结出有效可行的情绪调节方法。</p>
      <img src="../../assets/list1_5.png" alt="">
      <h5>“积极乐园”主题活动之一：“积极乐园”</h5>
      <p>目的：认知重建，用积极的信念面对压力事件。</p>
      <p>过程：完成“积极乐园-积极漂染厂”工作纸上压力事件“消极想法”和“积极想法”，分享实际经验，观看《力克胡哲精彩励志人生》并分享感受，最后进行总结和“爱的鼓励”。</p>
      <img src="../../assets/list1_6.png" alt="">
      <h5>“父母沟通有高招”主题活动之一：“冲突情景沟通模拟”</h5>
      <p>目的：实践所学沟通技巧，激发组员的参与性和创造性。</p>
      <p>过程：进行秘密问题游戏，写出害怕和父母、老师沟通的时候，放在秘密问题盒子里，每人抽一张，与大家分享沟通困难的部分，学习（1）用心听，听到父母话语背后的关心；（2）自信和爱的沟通法表达自己的感受和想法。</p>
      <img src="../../assets/list1_7.png" alt="">
      <h5>“我是一棵嫁接的树”主题活动之一：“我是一棵嫁接的树”</h5>
      <p>目的：理解嫁接的概念，认识到流动的优势，促进组员的身份认同感。</p>
      <p>过程：介绍并引申嫁接的观念，流动也是一种生命的嫁接，在一张大的中国地图上寻找各自家乡的位置，并且在家乡的位置上贴上一棵小树。讨论自己家乡具备的优点和资源，再做一棵树，写上在北京学到的优势，或者希望学到的优点、北京的资源等，然后把两棵树嫁接在一起，贴在北京位置，用一条线连接家乡位置和北京的位置，最后小组分享。</p>
      <img src="../../assets/list1_8.png" alt="">
      <h5>“未来由我做主”主题活动之一：“未来由我做主”</h5>
      <p>目的：引领组员在发现自己优势的基础上，为梦想做承诺。</p>
      <p>过程：讨论将来的梦想，播放视频《每个挫折都有它的意义》并进行讨论，完成《写给10年后的××》小小规划表，最后进行分享和爱的鼓励。</p>
      <img src="../../assets/list1_9.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: "list1",
  data() {
    return {
      
    };
  },
  props: ["listOrCon"],
   methods:{
    returnFun(){
      this.$emit("returnPage")
    }
  }
};
</script>
<style scoped src="../../assets/style/grandchild.css">
  /* @import '../assets/style/child.css'; */
</style>
<style scoped>
.tab>div{
  padding: 0;
}
.tab > div > h4{
  text-align: center;
  font-size: 24px
}
.tab > div > h5{
  text-align: center;
  margin: 30px 0;
  font-size: 20px
}
.tab > div > span{
  cursor: pointer;
  display: inline-block;
  padding: 4px 10px;
  border-radius: 5px;
  color: #7ecef4;
  border: solid 1px #7ecef4
}
</style>


// WEBPACK FOOTER //
// src/components/psychological/list1.vue